import React from 'react';

import { InventoryManagerProvider } from './InventoryManagerContext';
import { CoinManagerProvider } from './CoinManagerContext';
import { ExtrasManagerProvider } from './ExtrasManagerContext';

export function Managers(props) {
    return (
        <ExtrasManagerProvider>
            <InventoryManagerProvider>
                <CoinManagerProvider>
                    {props.children}
                </CoinManagerProvider>
            </InventoryManagerProvider>
        </ExtrasManagerProvider>
    );
}
